export const iconFontAwesomeMapsImages = (
	<i className="fa-solid fa-images"></i>
);
